import { render, staticRenderFns } from "./FAQ-modal.vue?vue&type=template&id=1427badd&scoped=true"
import script from "./FAQ-modal.vue?vue&type=script&lang=js"
export * from "./FAQ-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1427badd",
  null
  
)

export default component.exports